import { ScrollArea } from '@base-ui/react/scroll-area';
import type { ReactNode } from 'react';
import { cx } from '@/cva.config';

export interface ScrollPaneProps {
  children: ReactNode;
  className?: string;
  orientation?: 'vertical' | 'horizontal' | 'both';
  viewportClassName?: string;
}

export const ScrollPane = ({
  children,
  className,
  orientation = 'vertical',
  viewportClassName,
}: ScrollPaneProps) => {
  const showVertical = orientation === 'vertical' || orientation === 'both';
  const showHorizontal = orientation === 'horizontal' || orientation === 'both';

  return (
    <ScrollArea.Root className={cx('relative overflow-hidden', className)}>
      <ScrollArea.Viewport className={cx('size-full', viewportClassName)}>
        {children}
      </ScrollArea.Viewport>
      {showVertical && (
        <ScrollArea.Scrollbar
          className="flex w-1.5 touch-none p-px opacity-0 transition-opacity select-none data-hovering:opacity-100 data-scrolling:opacity-100"
          orientation="vertical"
        >
          <ScrollArea.Thumb className="flex-1 rounded-full bg-border-active" />
        </ScrollArea.Scrollbar>
      )}
      {showHorizontal && (
        <ScrollArea.Scrollbar
          className="flex h-1.5 touch-none p-px opacity-0 transition-opacity select-none data-hovering:opacity-100 data-scrolling:opacity-100"
          orientation="horizontal"
        >
          <ScrollArea.Thumb className="flex-1 rounded-full bg-border-active" />
        </ScrollArea.Scrollbar>
      )}
      {orientation === 'both' && <ScrollArea.Corner className="bg-border" />}
    </ScrollArea.Root>
  );
};
